"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_router_dom_1 = require("react-router-dom");
const system_1 = require("@mui/system");
/*
Need to use theme here bc we aren't using a MUI component.
NavLink is coming from react-router, so it doesn't use our
theme by default
*/
const NavLink = (0, system_1.styled)(react_router_dom_1.NavLink)(({ theme }) => ({
    all: 'initial',
    display: 'block',
    cursor: 'pointer',
    textDecoration: 'none',
    //@ts-ignore
    fontFamily: theme.typography.fontFamily,
    padding: '12px',
    //@ts-ignore
    fontSize: theme.typography.fontSize,
    lineHeight: '24px',
    color: theme.palette.grey[900],
    '&:hover': {
        color: theme.palette.primary.main,
        '& svg': {
            fill: theme.palette.primary.main,
        },
    },
    '&.active': {
        color: theme.palette.primary.main,
        '& svg': theme.palette.primary.main,
    },
}));
exports.default = NavLink;
